<template>
  <v-app class="primary">
    <router-view></router-view>
    <v-footer class="justify-center" color="transparent" height="auto">
      <a href="https://la-quincaillerie.fr/">
        <img src="@/assets/logo-white.png" alt="La Quincaillerie" class="mb-3">
      </a>
    </v-footer>
  </v-app>
</template>

<script>
export default {
  name: "App"
};
</script>

